import React from 'react'
import DemoVideo from 'components/DemoVideo'
import { XClose } from 'icons/XClose'

interface Props extends React.HTMLAttributes<HTMLElement> {
  videoUrl: string
  hide: () => void
}

const DemoVideoModal = ({ videoUrl, hide }: Props): JSX.Element => (
  <div className='fixed inset-0 flex items-center justify-center z-50 overflow-y-auto p-3'>
    <div className='max-w-max-w-1200 mx-auto block w-full'>
      <div className='fixed inset-0 transition-opacity' aria-hidden='true'>
        <div
          className='absolute inset-0 bg-gray-600 opacity-50'
          onClick={hide}
        />
      </div>
      <div
        className='inline-block text-left transition-all transform rounded-xl shadow-big w-full'
        role='dialog'
        aria-modal='true'
        aria-labelledby='modal-headline'
      >
        <div className='absolute -top-12 right-0 block'>
          <button
            type='button'
            className='text-white hover:text-opacity-80 focus:text-opacity-80 transition-colors'
            onClick={hide}
          >
            <XClose aria-label='Close video modal' className='w-8 h-8' />
          </button>
        </div>
        <div className='sm:flex sm:items-start'>
          <div className='w-full'>
            <DemoVideo
              url={videoUrl}
              thumbnail='/video-thumbnail.webp'
              autoplay
            />
          </div>
        </div>
      </div>
    </div>
  </div>
)

export default DemoVideoModal
